export default __webpack_public_path__ + "static/media/Group 5.3e0e0945.png";